import script from "./AdminProductDeletedListView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductDeletedListView.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductDeletedListView.vue?vue&type=style&index=0&id=02014248&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02014248"]])

export default __exports__